import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { shellHome } from "./navConfig";
import { SkeletonText } from "../ui";

/**
 * Tier-aware route helpers (UX-only — the backend scopes/authorizes for
 * real). Role resolution is async after session restore, so both wait on
 * roleReady with a quiet skeleton instead of guessing and flashing the
 * wrong workspace.
 */

function Waiting() {
  return (
    <div className="shell-page">
      <SkeletonText lines={5} />
    </div>
  );
}

/** /app index → tier home (referral: /app/home, staff: /app/today). */
export function ShellIndexRedirect() {
  const { roleReady, tier } = useAuth();
  if (!roleReady) {
    return <Waiting />;
  }
  return <Navigate to={shellHome(tier)} replace />;
}

/** Staff-only page: referral tier is sent to its own home, not scolded. */
export function StaffOnly({ children }) {
  const { roleReady, tier } = useAuth();
  if (!roleReady) {
    return <Waiting />;
  }
  return tier === "referral" ? <Navigate to="/app/home" replace /> : children;
}

/** Referral-shaped page: staff tiers land on Today instead. */
export function ReferralOnly({ children }) {
  const { roleReady, tier } = useAuth();
  if (!roleReady) {
    return <Waiting />;
  }
  return tier === "referral" ? children : <Navigate to="/app/today" replace />;
}
